export default {
    wait() {
        $('.cForm-Login__AjaxError').html('');
    },

    done(data) {
        if (data.success) {
            if (data.location) {
                window.location = data.location;
            } else {
                window.location.reload();
            }
        } else {
            $('.cForm-Login__AjaxError').append($('<p>').text(data.message));
        }
    },

    fail() {
        $('.cForm-Login__AjaxError').html('');
    },
};



// WEBPACK FOOTER //
// ./assets/js/component/ajax/login.js